export var IdAssetBundleCafe;
(function (IdAssetBundleCafe) {
    IdAssetBundleCafe["Cafe_1"] = "Cafe_1";
    IdAssetBundleCafe["Cafe_2"] = "Cafe_2";
    IdAssetBundleCafe["Cafe_3"] = "Cafe_3";
    IdAssetBundleCafe["Cafe_4"] = "Cafe_4";
    IdAssetBundleCafe["Cafe_5"] = "Cafe_5";
    IdAssetBundleCafe["Cafe_6"] = "Cafe_6";
    IdAssetBundleCafe["Cafe_7"] = "Cafe_7";
})(IdAssetBundleCafe || (IdAssetBundleCafe = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleCafe.ts
// module id = 2136
// module chunks = 3